$mol_frame $mol_embed_native
	attr *
		^
		allow <= allow \
		srcdoc <= html null
	fullscreen true
	accelerometer true
	autoplay true
	encription true
	gyroscope true
	pip true
	clipboard_read true
	clipboard_write true
